import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CheckForClubMembershipAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const clubMembership = createAsyncThunk('post/clubMembership', CheckForClubMembershipAPI);

export const ClubMembershipSlice = createSlice({
	name: 'clubMembership',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[clubMembership.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[clubMembership.rejected.toString()]: setAPIError,
		[clubMembership.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			const isSwipeBenifitAvailed = (payload?.rewards || []).find(
				(a: any) => a.source_module.toLowerCase() === 'swipe',
			);
			const clubVersion = payload?.club_id;
			state.data = {
				isSwipeBenifitAvailed: !!isSwipeBenifitAvailed,
				isBpClubAlreadyActive: !!(clubVersion === 1 && !!payload?.eligibile),
			};
		},
	},
});

interface IStates {
	[ClubMembershipSlice.name]: ReturnType<typeof ClubMembershipSlice.reducer>;
}

export const clubMembershipSelector = (state: IStates): any => {
	return state[ClubMembershipSlice.name] || {};
};

export const useClubMembership = (): any => useSelector(clubMembershipSelector);

export const checkClubMembership =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(clubMembership(params));
		return;
	};

export const resetClubMembership =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(ClubMembershipSlice.actions.RESET());
		return;
	};
